@if (orderData) {
  <div class="ticket-details">
    <section class="ticket-section">
      <h2 class="ticket-section__title">{{'web.ticketValidityLabel' | translate }}</h2>
      <div class="ticket-section__card">
        <p class="ticket-section__text">{{ orderData.specialTicket?.ticketValidityText?.[locale] }}</p>
      </div>
    </section>
    <section class="ticket-section">
      <h2 class="ticket-section__title">{{'web.ticketPriceAndPaymentLabel' | translate }}</h2>
      <div class="ticket-section__card ticket-section__card--payment">
        <div class="ticket-section__info-item">
          <span class="ticket-section__label">{{'web.ticketPriceLabel' | translate }}</span>
          <span class="ticket-section__value">{{ orderData.price | price: locale }}</span>
        </div>
        <div class="ticket-section__info-item">
          <span class="ticket-section__label">{{'web.ticketNumberLabel' | translate }}</span>
          <span class="ticket-section__value">{{ orderData.ticketNumber }}</span>
        </div>
        <div class="ticket-section__info-item">
          <span class="ticket-section__label">{{'web.ticketStatusLabel' | translate }}</span>
          <span class="ticket-section__value">{{ getOrderStatusText(orderData.status) }}</span>
        </div>
        <div class="ticket-section__info-item">
          <span class="ticket-section__label">{{'web.ticketPurchaseTimeLabel' | translate }}</span>
          <span class="ticket-section__value">
            {{ orderData.purchaseDate | danishTime | date:'dd.MM.yy, HH:mm:ss' }}
          </span>
        </div>
      </div>
    </section>
    <section class="ticket-section">
      <h2 class="ticket-section__title">{{'web.ticketEventInformationLabel' | translate }}</h2>
      <div class="ticket-section__card">
        <p class="ticket-section__text">{{ utility.getLocalizedText(orderData.specialTicket?.ticketDescription, locale) }}</p>
      </div>
    </section>
    <section class="ticket-section">
      <h2 class="ticket-section__title">{{'web.ticketGeneralInformationLabel' | translate }}</h2>
      <div class="ticket-section__card">
        <p class="ticket-section__text">{{'web.generalInformation' | translate }}</p>
      </div>
    </section>
  </div>
}
